var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDnList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m472 160h-32v-80c0-8.822-7.178-16-16-16h-32v-40c0-13.233-10.767-24-24-24h-224c-13.233 0-24 10.767-24 24v40h-32c-8.822 0-16 7.178-16 16v80h-32c-22.056 0-40 17.944-40 40v176c0 22.056 17.944 40 40 40h80v72c0 13.233 10.767 24 24 24h224c13.233 0 24-10.767 24-24v-72h80c22.056 0 40-17.944 40-40v-176c0-22.056-17.944-40-40-40zm-48-80v80h-32v-80zm-288-56c0-4.411 3.589-8 8-8h224c4.411 0 8 3.589 8 8v136h-240c0-1.635 0-130.211 0-136zm-48 56h32v80h-32zm288 408c0 4.411-3.589 8-8 8h-224c-4.411 0-8-3.589-8-8v-136h240zm120-112c0 13.233-10.767 24-24 24h-80v-48h16c4.418 0 8-3.582 8-8s-3.582-8-8-8c-28.657 0-290.883 0-304 0-4.418 0-8 3.582-8 8s3.582 8 8 8h16v48h-80c-13.233 0-24-10.767-24-24v-176c0-13.233 10.767-24 24-24h432c13.233 0 24 10.767 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456 192c-13.233 0-24 10.767-24 24s10.767 24 24 24 24-10.767 24-24-10.767-24-24-24zm0 32c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 192c-13.233 0-24 10.767-24 24s10.767 24 24 24 24-10.767 24-24-10.767-24-24-24zm0 32c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 376h-168c-4.418 0-8 3.582-8 8s3.582 8 8 8h168c4.418 0 8-3.582 8-8s-3.582-8-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 416h-168c-4.418 0-8 3.582-8 8s3.582 8 8 8h168c4.418 0 8-3.582 8-8s-3.582-8-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 456h-168c-4.418 0-8 3.582-8 8s3.582 8 8 8h168c4.418 0 8-3.582 8-8s-3.582-8-8-8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnList);
export default __webpack_public_path__ + "static/media/dn_list.abc0f6f0.svg";
export { ForwardRef as ReactComponent };